module.exports = __webpack_public_path__ + "media/images/avatar_dani-367a938c9d867f04bc8f849ac14689d7.jpg";